import { render, staticRenderFns } from "./NadpisIndex.vue?vue&type=template&id=5f2af0dc&scoped=true"
import script from "./NadpisIndex.vue?vue&type=script&lang=js"
export * from "./NadpisIndex.vue?vue&type=script&lang=js"
import style0 from "./NadpisIndex.vue?vue&type=style&index=0&id=5f2af0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2af0dc",
  null
  
)

export default component.exports